import React from 'react';
import Title from 'components/UI/Title';
import Image from 'components/UI/Image';
import Link from 'components/UI/Link';
import List from 'components/UI/List';
import { useTrans, useLang } from 'utils/localisation';

import * as styles from './MobileCard.module.scss';

export default function MobileCard({ id = 'industry-card', title, description, list, img, link }) {
  const t = useTrans(['common']);
  const lang = useLang();
  const globalUrl = lang === 'az' ? 'https://andersenlab.com' : '';
  const linkName = lang === 'uk' ? t('learnMore') : t('seeMore');

  return (
    <article id={id} className={styles.card}>
      <Image className={styles.picture} classImage={styles.image} src={img} />
      <Title tag="h3" className={styles.title}>
        {title}
      </Title>
      {description && <p>{description}</p>}
      {list && <List items={list} theme="smallMarginChecked" size="mdSame" />}
      <Link className={styles.link} href={`${globalUrl}${link}`}>
        {linkName}
      </Link>
    </article>
  );
}
